var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / MT") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-MT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-2",
    fill: "#DE233C",
    mask: "url(#mask-2)",
    x: 14.6666667,
    y: 0,
    width: 13.3333333,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66683342,2.33333333 L5.66616671,3.66641666 L7,3.66674995 L7,5.66683329 L5.66616671,5.66616671 L5.66683329,7 L3.66674995,7 L3.66641666,5.66616671 L2.33333333,5.66683342 L2.33333333,3.66675001 L3.66641666,3.66641666 L3.66675001,2.33333333 L5.66683342,2.33333333 Z",
    id: "Rectangle-364",
    strokeOpacity: 0.66,
    stroke: "#7B716A",
    strokeWidth: 0.666666667,
    fill: "#CCCCCD",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-20",
    fill: "#7B716A",
    mask: "url(#mask-2)",
    cx: 4.66666667,
    cy: 4.66666667,
    r: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMt);
export default __webpack_public_path__ + "static/media/MT.599c20fd872481e59decd71611befbb8.svg";
export { ForwardRef as ReactComponent };